import { Component, Children, cloneElement } from 'react';
import AccountManager from 'lib/AccountManager';
import PropTypes from 'prop-types';
import ParseApp from 'lib/ParseApp';


export default class SettingsData extends Component {
  state = {};

  async componentDidMount() {
    const { fields } = await this.context.currentApp.fetchSettingsFields();
    const { currentUser, currentCustomer } = await AccountManager.currentUser();

    this.setState({ currentUser, currentCustomer, fields });
  }

  saveChanges(changes) {
    return this.context.currentApp.saveSettingsFields({ appName: this.context.currentApp.name, fields: changes })
      .then((data) => {
        return this.context.currentApp.fetchSettingsFields().then(({ fields }) => {
          this.setState({ fields });

          return data;
        });
      });
  }

  render() {
    let isOwner;

    if (this.state.currentUser && this.state.currentUser.id) {
      isOwner = this.context.currentApp.user.objectId === this.state.currentUser.id;
    }

    return cloneElement(Children.only(this.props.children), {
      availableParseServerVersions: this.props.availableParseServerVersions,
      currentUser: this.state.currentUser,
      currentCustomer: this.state.currentCustomer,
      initialFields: this.state.fields,
      saveChanges: this.saveChanges.bind(this),
      isOwner,
    });
  }
}

SettingsData.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
